import * as React from 'react';
import {WebinarObject} from 'api/webinar/types';

export interface WebinarBuilderContextValue {
  webinar: Partial<WebinarObject>;
  setWebinar(webinar: Partial<WebinarObject>): void;
}

export const WebinarBuilderContext
  = React.createContext<Partial<WebinarBuilderContextValue>>({});

export default WebinarBuilderContext;
